import style from './InformationBlock.module.scss'

type PropsType = {
  title: string
  children: React.ReactNode
}
// блок с информацией о странице
export function InformationBlock({ title, children }: PropsType) {
  return (
    <div className={style.informationBlock}>
      <div className={style.title}>
        <span className='h4'>{title}</span>
      </div>

      <div className={style.content}>{children}</div>
    </div>
  )
}
